import posthog from 'posthog-js'

const posthogKey = process.env.REACT_APP_POSTHOG_KEY
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com'

if (posthogKey) {
    posthog.init(posthogKey, {
        api_host: posthogHost,
        person_profiles: 'identified_only',
        capture_pageview: true,
        capture_pageleave: true,
    })
}

export const isPostHogEnabled = Boolean(posthogKey)

export default posthog
